<template>
  <AddMentor update />
</template>
<script>
import appConfig from '@/app.config'
import AddMentor from '../../../components/dadban/mentors/AddMentor.vue'
export default {
  page: {
    title: 'ویرایش اطلاعات منتور',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-edit-mentors',
  components: {
    AddMentor,
  },
}
</script>
